/* eslint-disable jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
import Select from '../_utils/select-wrapper';
import { builderDispatch, WebUI } from '../_utils/ui';
import LoaderAdditionalOptions from './additional-options';
import { DefaultsEvents } from '../_prints-builder/common/events/event-declarations';

class PrintSizeSelector extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      selectedSize: undefined,
    };
  }

  componentDidMount() {
    this.builderDispatchToken = builderDispatch.register(payload => {
      switch (payload.type) {
        case WebUI.UPLOAD_ABORTED:
          this.setState({ selectedSize: undefined });
          break;
      }
    });
  }

  componentWillUnmount() {
    builderDispatch.unregister(this.builderDispatchToken);
  }

  get sizes() {
    const { additionalOptions } = this.context;

    return additionalOptions[LoaderAdditionalOptions.PRINT_SIZES] || [];
  }

  get hasNoSizes() {
    return this.sizes.length === 0;
  }

  selectedPrintSizeKey() {
    return (this.sizes.find(size => size.selected) || {}).key;
  }

  printSizeChanged = sizeKey => {
    this.setState({
      selectedSize: sizeKey,
    });

    builderDispatch.dispatch({
      type: DefaultsEvents.CHANGE_SIZE,
      sizeKey,
    });
  };

  render() {
    if (this.hasNoSizes) {
      return null;
    }

    const { selectedSize } = this.state;
    const sizeOptions = this.sizes.map(size => {
      return {
        value: size.key,
        label: size.title,
      };
    });

    return (
      <div className="default-print-size col form-group my-2 d-flex align-items-center justify-content-center">
        <label
          htmlFor="print-size-select"
          className="col-3 col-sm-2 col-md-4 col-lg-5 col-xl-3 col-form-label text-center px-0">
          Print Size:
        </label>
        <Select
          className="col-3 col-sm-2 col-md-3 col-lg-5 col-xl-3 text-center badge-pill"
          id="print-size-select"
          label="Print Size"
          name="default-print-size"
          options={sizeOptions}
          value={selectedSize || this.selectedPrintSizeKey()}
          onChange={this.printSizeChanged}
        />
      </div>
    );
  }
}

PrintSizeSelector.contextTypes = {
  additionalOptions: PropTypes.object,
};

export default PrintSizeSelector;
